import { theme } from '../theme';

const getBackgroundFromItem = (asset) => {
  switch(asset.getType()) {
    case 'weapon':
      return theme.baseRed;
    case 'object':
      return asset.getEffects().includes('FOOD') ? theme.baseGreen : theme.basePurple;
    case 'armor':
      return theme.baseOrange;
    default:
      return theme.basePurple;
  }
};

export default getBackgroundFromItem;
